import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class CreatedAtColumn extends Column {
    title = 'table.employerPackage.createdAt';
    property = 'createdAt';
    sortField = 'createdAt';
    sortable = true;
    type: CellDisplay = CellDisplay.date;
}
